export const scrollState = {
    progress: 0,
    lenis: null,
};
